"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.registerCreator = registerCreator;
var _inputRefCreator = require("../input-ref-creator");
function registerCreator(getState, dispatch, reconcile, eventHandler) {
  return rules => inputElement => (0, _inputRefCreator.inputRefCreator)(getState, dispatch, reconcile, eventHandler)(inputElement, rules);
}